import { Flat } from "@mgi-labs/preview";

const caviarFlat: Flat = new Flat({
  name: "Caviar",
  paper: {
    layer: { url: "BlackSatin.png", name: "paper" },
  },
  design: {
    recto: {
      color: {
        layer: {
          url: "color.png",
          url_SD: "color.png",
          name: "color",
          width: 2048,
          height: 2048,
        },
      },
      silverFoil: {
        layer: {
          url: "silverFoil.png",
          url_SD: "silverFoil.png",
          name: "Foil Silver",
        },
      },
      varnish: {
        layer: { url: "varnish.png", url_SD: "varnish.png", name: "Varnish" },
      },
    },
    mask: {
      url: "mask.png",
      width: 878,
      height: 878,
    },
  },
});

export default caviarFlat;
